import React, { useEffect, useState } from 'react';
import {Skeleton, Box, Typography, Grid} from "@mui/material";
import DonutChart from "react-donut-chart";
import RegionSelect from "./region-select.component";
import StyledPaper from "../common/styled-paper.component";
import useAnalytics from "./../../hooks/useAnalytics";
import EmptyIcon from "../../assets/images/empty-box.png";

const MostVerifiedProductsDonutChart = (props) => {

  const {isLoadingTopVerifiedProduct, error, top_verified_products, getTopVerifiedProducts } = useAnalytics();
  const [region, setRegion] = useState(null);
  const [country, setCountry] = useState(null);
  const [reactDonutChartdata, setReactDonutChartData] = useState([]);

  useEffect(()=>{
    if(country == null) return;
    if(region == null) return;
    getTopVerifiedProducts(country, region);
  }, [region, country]);

  useEffect(()=>{
    if(top_verified_products == null) return;
    setReactDonutChartData(formatTopVerifiedProducts(top_verified_products));
  }, [top_verified_products]);

  function formatTopVerifiedProducts(top_verified_products){
    var sliceColors = ["#C309F1", "#F109A2", "#09D5F1", "#3939D1", "#BF40A3"];
    var data = [];
    var colorCounter = 0;
    for(var i=0; i < top_verified_products.length; i++){
      var jsonObject = {
        label: top_verified_products[i].product_name,
        value: top_verified_products[i].verificationCount,
      };
      if(i <= colorCounter){
        colorCounter = 0;
      }
      jsonObject.color = sliceColors[colorCounter];
      colorCounter++;
      data.push(jsonObject);
    }
    return data;
  }

  const reactDonutChartBackgroundColor = [
    "#C309F1",
    "#F109A2",
    "#09D5F1",
    "#3939D1",
    "#BF40A3",
  ]

  const reactDonutChartInnerRadius = 0.4;
  const reactDonutChartSelectedOffset = 0.04;

  const reactDonutChartHandleClick = (item, toggled) => {
    if (toggled) {
      //
    }
  };

  let reactDonutChartStrokeColor = "#FFFFFF";

  const reactDonutChartOnMouseEnter = (item) => {
    let color = reactDonutChartdata.find((q) => q.label === item.label).color;
    reactDonutChartStrokeColor = color;
  };

  return (
    <StyledPaper>

      <Grid container sx={{pb: 2}}>
        <Grid item xs={12} sm={6} lg={9}>
          <Typography>Most Verified Products Across Locations</Typography>
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <RegionSelect onRegionChange={setRegion} onCountryChange={setCountry}/>
        </Grid>
      </Grid>

      <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        {isLoadingTopVerifiedProduct ?
          <Skeleton variant="rounded" sx={{backgroundColor: "#d8d8fdbd"}} width="100%" height="420px" /> 
        :
          (!isLoadingTopVerifiedProduct && top_verified_products?.length === 0) ?
            <Box sx={{textAlign: "center", flexDirection: "column", mb: 10,
              justifyContent: "center", display: "flex", alignItems: "center", 
            }}>
              <img alt="empty-data-icon" src={EmptyIcon} width="110" style={{marginTop: "72px"}} />

              <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
                No data available for the selected location
              </Typography>
            </Box>
        :   
          <DonutChart
            onMouseEnter={(item) => reactDonutChartOnMouseEnter(item)}
            strokeColor={reactDonutChartStrokeColor}
            data={reactDonutChartdata}
            colors={reactDonutChartBackgroundColor}
            innerRadius={reactDonutChartInnerRadius}
            selectedOffset={reactDonutChartSelectedOffset}
            onClick={(item, toggled) => reactDonutChartHandleClick(item, toggled)}
            className={"verificationproducts-donutchart"}
          />
        }
      </Box>

    </StyledPaper>
  )
}

export default MostVerifiedProductsDonutChart;
